const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const MONTH_TO_INDEX: Record<string, number> = MONTHS.reduce((acc, month, index) => ({ ...acc, [month]: index }), {});
const MONTH_TO_TWO_DIGIT: Record<string, string> = MONTHS.reduce(
   (acc, month, index) => ({ ...acc, [month]: String(index + 1).padStart(2, '0') }),
   {}
);

const FIRST_TERTIAL = ['Sep', 'Oct', 'Nov', 'Dec'];
const SECOND_TERTIAL = ['Jan', 'Feb', 'Mar', 'Apr'];

const isFirstTertial = (month: string): boolean => FIRST_TERTIAL.includes(month);

const isSecondTertial = (month: string): boolean => SECOND_TERTIAL.includes(month);

export const getCurrentFiscalYear = (): number => {
   const today = new Date();
   return today.getMonth() >= 8 ? today.getFullYear() : today.getFullYear() - 1;
};

export const getCalendarYearByMonth = (fiscalYear: number, month: string): number => (isFirstTertial(month) ? fiscalYear : fiscalYear + 1);

export const getTertialByMonth = (month: string): number => {
   if (isFirstTertial(month)) return 1;
   if (isSecondTertial(month)) return 2;
   return 3;
};

export const fiscalPeriodToDate = (fiscalPeriod: string | null): Date | null => {
   if (!fiscalPeriod) return null;

   const [fiscalYear, , month] = fiscalPeriod.split('-');
   const calendarYear = getCalendarYearByMonth(parseInt(fiscalYear), month);

   return new Date(calendarYear, MONTH_TO_INDEX[month], 1);
};

export const dateToFiscalPeriod = (date: Date | null): string | null => {
   if (!date) return null;

   const month = MONTHS[date.getMonth()];
   const calendarYear = date.getFullYear();
   const fiscalYear = date.getMonth() >= 8 ? calendarYear : calendarYear - 1;
   const tertial = getTertialByMonth(month);

   return `${fiscalYear}-${tertial}-${month}`;
};

export const formatBackendDateForDisplay = (yearMonth: string | null): string => {
   if (!yearMonth) return '';

   const [year, monthNum] = yearMonth.split('-');
   const monthIndex = parseInt(monthNum) - 1;

   return `${MONTHS[monthIndex]} ${year}`;
};

export const backendToFiscalPeriod = (yearMonth: string | null): string | null => {
   if (!yearMonth) return null;

   const [year, monthNum] = yearMonth.split('-');
   const monthIndex = parseInt(monthNum) - 1;
   const month = MONTHS[monthIndex];
   const calendarYear = parseInt(year);
   const fiscalYear = isFirstTertial(month) ? calendarYear : calendarYear - 1;
   const tertial = getTertialByMonth(month);

   return `${fiscalYear}-${tertial}-${month}`;
};

export const fiscalPeriodToBackend = (fiscalPeriod: string): string => {
   const [fiscalYear, , month] = fiscalPeriod.split('-');
   const calendarYear = getCalendarYearByMonth(parseInt(fiscalYear), month);

   return `${calendarYear}-${MONTH_TO_TWO_DIGIT[month]}`;
};

export const getFiscalYearMonths = (fiscalYear: number) => [
   ...FIRST_TERTIAL.map((month) => ({
      month,
      tertial: 1,
      calendarYear: fiscalYear,
      fiscalPeriod: `${fiscalYear}-1-${month}`,
   })),

   ...SECOND_TERTIAL.map((month) => ({
      month,
      tertial: 2,
      calendarYear: fiscalYear + 1,
      fiscalPeriod: `${fiscalYear}-2-${month}`,
   })),

   ...['May', 'Jun', 'Jul', 'Aug'].map((month) => ({
      month,
      tertial: 3,
      calendarYear: fiscalYear + 1,
      fiscalPeriod: `${fiscalYear}-3-${month}`,
   })),
];
